module.exports = __webpack_public_path__ + "img/stripe.fabe4cc5.svg";